export const DEFAULT_CATALOG_PARAMS = {
    page:     1,
    per_page: 32
};